import { z } from "zod";
export const ManagedHostingProductDispositionV1Schema = z
    .object({
    schemaVersion: z.literal("managed-hosting-product-disposition.v1.0"),
    productPath: z.literal("DEFERRED_POST_PILOT"),
    exitPath: z.literal("DEPARTURE_KIT_V1"),
    forbidsManagedHostingAppPackage: z.literal(true),
    recordedAt: z.string().datetime(),
})
    .strict();
export function buildManagedHostingDeferDisposition(recordedAt) {
    return ManagedHostingProductDispositionV1Schema.parse({
        schemaVersion: "managed-hosting-product-disposition.v1.0",
        productPath: "DEFERRED_POST_PILOT",
        exitPath: "DEPARTURE_KIT_V1",
        forbidsManagedHostingAppPackage: true,
        recordedAt,
    });
}
export const FORBIDDEN_MANAGED_HOSTING_APP_NAMES = ["hosting", "managed-hosting"];
export function assertNoManagedHostingAppPackage(appNames) {
    for (const forbidden of FORBIDDEN_MANAGED_HOSTING_APP_NAMES) {
        if (appNames.includes(forbidden)) {
            throw new Error("managed_hosting_app_forbidden");
        }
    }
}
//# sourceMappingURL=managed-hosting-product-boundary.js.map